const services = [
  {
    subTitle: "Effortless Staking",
    title: "Stake Your NFTs with Ease",
    description:
      "Our user-friendly platform makes it easy to stake your NFTs in just a few clicks. No technical expertise required.",
    image: "/assets/images/effortless-staking.png",
    href: "/effortless-staking",
    alt: "Effortless NFT Staking",
  },
  {
    subTitle: "High Rewards",
    title: "Earn Competitive Rewards",
    description:
      "Earn substantial rewards and watch your NFT portfolio grow with our competitive staking returns.",
    image: "/assets/images/high-rewards.png",
    href: "/high-rewards",
    alt: "High Staking Rewards",
  },
  {
    subTitle: "Secure and Reliable",
    title: "Your NFTs are Safe with Us",
    description:
      "Your assets' security is our top priority. Our robust platform ensures your NFTs are safe and secure.",
    image: "/assets/images/secure-reliable.png",
    href: "/secure-reliable",
    alt: "Secure and Reliable Platform",
  },
  {
    subTitle: "Diverse NFT Support",
    title: "Support for Various NFTs",
    description:
      "SoftStake supports a wide range of NFTs, from digital art to collectibles. Stake any NFT you own.",
    image: "/assets/images/diverse-support.png",
    href: "/diverse-nft-support",
    alt: "Diverse NFT Support",
  },
];

const CardsSection = () => {
  return (
    <section
      className="-mt-36 pt-36 pb-28 relative overflow-hidden"
      id="services"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1
            data-aos="fade-up"
            className="font-heading text-4xl lg:text-5xl font-bold text-gray-100 mb-24"
          >
            <span>
              Explore <span className="text-color">SoftStake's</span> Key
              Features
            </span>
          </h1>
        </div>

        <div className="space-y-16 lg:space-y-24 xl:space-y-36 max-w-4xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center service-item"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div
                className={`col ${
                  index % 2 !== 0
                    ? "image-right order-first lg:order-last"
                    : "image-left"
                }`}
              >
                <div className="relative w-3/4 mx-auto">
                  <img
                    className="h-full w-full object-contain"
                    src={service.image}
                    alt={service.alt}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100 + 100}
                  />
                </div>
              </div>
              <div
                className={`col ${
                  index % 2 !== 0 ? "content-right" : "content-left"
                } text-center lg:text-left`}
              >
                <div>
                  <h6 className="mb-4 font-semibold uppercase text-primary text-sm md:text-base">
                    {service.subTitle}
                  </h6>
                  <h3 className="mb-5 font-bold font-clash-display text-2xl md:text-4xl max-w-xs mx-auto lg:mx-0">
                    {service.title}
                  </h3>
                  <p className="text-white/70 text-lg md:text-xl text-balance max-w-sm mx-auto lg:mx-0">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardsSection;
